import axios from 'axios';

// 这里取决于登录的时候将 token 存储在哪里
// 不再预取 token，而是从 localStorage 动态获取

const instance = axios.create({
    timeout: 5000,
    headers: {
        'Content-Type': 'application/json'
    }
});

// 添加请求拦截器
instance.interceptors.request.use(
    config => {
        // 从 localStorage 获取 token，避免循环依赖
        const token = localStorage.getItem('access_token') || localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 添加响应拦截器
instance.interceptors.response.use(
    response => {
        // 只要状态码在 2xx 范围内，直接返回 response
        return response;
    },
    error => {
        // 相应错误处理
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 清除登录态并触发全局事件，通知应用显示登录模态框
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('refreshToken');
                    localStorage.removeItem('userInfo');
                    window.dispatchEvent(new CustomEvent('auth:showLoginModal'));
                    break;
                case 403:
                    // 无权限访问
                    break;
                case 404:
                    break;
                case 500:
                    break;
                default:
                    console.log('其他错误信息');
            }
        }
        return Promise.reject(error);
    }
);

export default instance;